import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsModalContentCss = "pds-modal-content{display:block;-ms-flex:1 1 auto;flex:1 1 auto;overflow-y:auto;width:100%}pds-modal-content:has(.pds-modal-content--border-none){border:0}pds-modal-content:has(.pds-modal-content--border-both){-webkit-border-after:1px solid var(--pine-color-grey-200);border-block-end:1px solid var(--pine-color-grey-200);-webkit-border-before:1px solid var(--pine-color-grey-200);border-block-start:1px solid var(--pine-color-grey-200)}pds-modal-content:has(.pds-modal-content--border-top){-webkit-border-before:1px solid var(--pine-color-grey-200);border-block-start:1px solid var(--pine-color-grey-200)}pds-modal-content:has(.pds-modal-content--border-bottom){-webkit-border-after:1px solid var(--pine-color-grey-200);border-block-end:1px solid var(--pine-color-grey-200)}.pds-modal-content{display:block;-ms-flex:1 1 auto;flex:1 1 auto;min-height:0;overflow-y:auto;width:100%}";

const PdsModalContent$1 = /*@__PURE__*/ proxyCustomElement(class PdsModalContent extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        /**
         * The border style for the content area. Automatically set based on available space of the modal content.
         * @default 'none'
         */
        this.border = 'none';
        this.contentMaxHeight = '60vh';
    }
    componentDidLoad() {
        const slotContent = this.el.firstElementChild;
        const isScrollable = slotContent.scrollHeight > slotContent.clientHeight;
        this.border = isScrollable ? 'both' : 'none';
        this.calculateMaxHeight();
        window.addEventListener('resize', this.calculateMaxHeight.bind(this));
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.calculateMaxHeight.bind(this));
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }
    /**
     * Calculates the max-height based on header and footer heights
     */
    calculateMaxHeight() {
        // Find the modal element (parent of this component)
        const modalElement = this.el.closest('pds-modal');
        if (!modalElement)
            return;
        setTimeout(() => {
            // Find header and footer elements
            const headerElement = modalElement.querySelector('pds-modal-header');
            const footerElement = modalElement.querySelector('pds-modal-footer');
            // Get header and footer heights
            const headerHeight = headerElement ? headerElement.offsetHeight : 0;
            const footerHeight = footerElement ? footerElement.offsetHeight : 0;
            // Set the max-height as a calculation
            if (headerHeight > 0 || footerHeight > 0) {
                // Calculate the available height by subtracting:
                // 1. Header and footer heights
                // 2. Modal padding (48px)
                // 3. Additional space for modal positioning (6vh)
                // 4. Extra adjustment for perfect fit (50px)
                const viewportAdjustment = Math.round(window.innerHeight * 0.06); // 6vh approximation
                const totalReduction = headerHeight + footerHeight + 48 + viewportAdjustment + 50;
                // Set the content max height
                this.contentMaxHeight = `calc(100vh - ${totalReduction}px)`;
                // Apply the style directly to ensure it takes effect
                const contentElement = this.el.querySelector('.pds-modal-content');
                if (contentElement) {
                    contentElement.style.maxHeight = this.contentMaxHeight;
                }
            }
            else {
                this.contentMaxHeight = '60vh'; // Default fallback
            }
        }, 100); // Delay to ensure DOM is fully rendered
        // Set up mutation observer if not already done
        if (!this.mutationObserver && modalElement) {
            this.mutationObserver = new MutationObserver(() => {
                this.calculateMaxHeight();
            });
            // Observe changes to the modal's children
            this.mutationObserver.observe(modalElement, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        }
    }
    render() {
        return (h(Host, { key: '6b214e3462d8e1e1cb58d6c0075b3143e0db2d51' }, h("div", { key: '2f6a2daeb09a99f096cd46230813fe1b9a6950e9', class: {
                'pds-modal-content': true,
                [`pds-modal-content--border-${this.border}`]: true
            }, style: { maxHeight: this.contentMaxHeight }, tabindex: "-1" }, h("slot", { key: '8392cc48a2dba0f32d4a83e642bd3f295832251b' }))));
    }
    get el() { return this; }
    static get style() { return pdsModalContentCss; }
}, [4, "pds-modal-content", {
        "border": [513],
        "contentMaxHeight": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-modal-content"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-modal-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsModalContent$1);
            }
            break;
    } });
}

const PdsModalContent = PdsModalContent$1;
const defineCustomElement = defineCustomElement$1;

export { PdsModalContent, defineCustomElement };
//# sourceMappingURL=pds-modal-content.js.map

//# sourceMappingURL=pds-modal-content.js.map